import React from 'react';

const Features = () => {
    return (
        <>
            <div className="row">
                <div className="col-sm-6 ">
                    <div className="card border-0 bg-transparent">
                        <div className="card-body bg-white my-2 border-bottom border-info border-3">
                            <div className="card-icon-1 d-flex justify-content-center">
                                <img src="/assets/goal.svg" alt="vision" className="w-100 pt-2"/>
                            </div>
                            <h4 className="card-title pt-1">Our Goal</h4>
                            <p className="card-text text-secondary">To improve the level of technological know-how in our society, while encouraging high level of creativity.</p>
                        </div>
                    </div>
                </div>
                <div className="col-sm-6 ">
                    <div className="card border-0 bg-transparent">
                        <div className="card-body bg-white my-2 border-bottom border-info border-3">
                            <div className="card-icon d-flex justify-content-center">
                                <img src="/assets/vision.svg" alt="vision" className="w-100 pt-2"/>
                            </div>
                            <h4 className="card-title pt-1">Our Vision</h4>
                            <p className="card-text text-secondary">To become the leading name in Engineering hands-on training/mentorship program </p>
                        </div>
                    </div>
                </div>
                <div className="col-sm-6 ">
                    <div className="card border-0 bg-transparent">
                        <div className="card-body bg-white my-2 border-bottom border-info border-3">
                            <div className="card-icon d-flex justify-content-center">
                                <img src="/assets/todo.svg" alt="vision" className="w-100"/>
                            </div>
                            <h4 className="card-title pt-2">Our Mission</h4>
                            <p className="card-text text-secondary">To close-up the gap between the theoritical(classroom) and practical experience of Engineers through a well structured mentorship program for better career opportunity</p>
                        </div>
                    </div>
                </div>
                <div className="col-sm-6 d-flex justify-content-center align-items-center">
                    <div className="card border-0 bg-transparent">
                        <div className="card-body my-2 border-info border-3">
                            <a href="/about" className="learn-more btn btn-md btn-outline-secondary">
                                <span className="px-2">
                                    Learn more
                                </span>
                                <i className="fas fa-arrow-right text-white"></i>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Features;